import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { eChieuCaoCanNangActionTypeIds, IChieuCaoCanNangActionTypes } from "../../action-types/chieu-cao-can-nang/IChieuCaoCanNangActionTypes"
import { IBaseResponeModel } from "../../../models/response/base-response"
import { actions } from "../../actions/actionsWrapper"
import { IChieuCaoCanNang } from "../../../model/respone/sis/IChieuCaoCanNang"
import { chieuCaoCanNangApi } from "../../../api/chieuCaoCanNangApi"
import { IChieuCaoCanNangSelectByLopRequest } from "../../../model/request/sis/IChieuCaoCanNangSelectByLopRequest"
import { lopApi } from "../../../api/lopApi"
import { ILopSelectedItemRequest } from "../../../models/request/danh-muc/ILopSelectedItemRequest"


export function* chieuCaoCanNangSaga(): any {
    yield takeLatest(eChieuCaoCanNangActionTypeIds.LOAD_HOC_SINH_START, loadHocSinhWorker)
    yield takeLatest(eChieuCaoCanNangActionTypeIds.LOAD_KETQUA_START, loadKetQuaWorker)
    yield takeEvery(eChieuCaoCanNangActionTypeIds.SAVE_START, saveKetQuaWorker)
    yield takeEvery(eChieuCaoCanNangActionTypeIds.DELETE_START, deleteKetQuaWorker)
}

function* loadHocSinhWorker(action: IChieuCaoCanNangActionTypes): any {
    const request = action.payload as ILopSelectedItemRequest
    // Backend expects dm_lop_ids (array), not dm_lop_id (single)
    const apiRequest = { dm_lop_ids: [request.dm_lop_id], nam_hoc: request.nam_hoc }
    const res: IBaseResponeModel = yield call(() => lopApi.SelectHocSinhByLopsAsync(apiRequest as any))
    if (res.is_success) {
        yield put(actions.chieuCaoCanNang.LOAD_HOC_SINH_SUCCESS(res.data))
    } else {
        yield put(actions.chieuCaoCanNang.LOAD_HOC_SINH_ERROR(res.message ?? ""))
    }
}

function* loadKetQuaWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.selectByLop, action.payload as IChieuCaoCanNangSelectByLopRequest)
    if (res.is_success) {
        yield put(actions.chieuCaoCanNang.LOAD_KETQUA_SUCCESS(res.data))
    } else {
        yield put(actions.chieuCaoCanNang.LOAD_KETQUA_ERROR(res.message ?? ""))
    }
}

function* saveKetQuaWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.save, action.payload as IChieuCaoCanNang)
    if (res.is_success) {
        yield put(actions.chieuCaoCanNang.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.chieuCaoCanNang.SAVE_ERROR(res.message ?? ""))
    }
}

function* deleteKetQuaWorker(action: IChieuCaoCanNangActionTypes): any {
    const res: IBaseResponeModel = yield call(chieuCaoCanNangApi.delete, action.payload as number)
    if (res.is_success) {
        yield put(actions.chieuCaoCanNang.DELETE_SUCCESS(res.data))
    } else {
        yield put(actions.chieuCaoCanNang.DELETE_ERROR(res.message ?? ""))
    }
}
